import { ApiOptions } from '../../api-options.decorator';
import { DefaultParams } from '../../default-params.model';
import { ParamsAdapter } from '../../params.adapter';

import { ApiBaseMidBack } from './base';
import { CreatePpaAsProdRequest } from './types/createPpaAsProdRequest';
import { PpaAsProdCreationViewModel } from './types/ppaAsProdCreationViewModel';
import { PpaAsProdVolumesViewModel } from './types/ppaAsProdVolumesViewModel';

/**
 * @internal
 */
export class ApiMidbackDreams extends ApiBaseMidBack {
  createPPA(params: CreatePpaAsProdRequest) {
    return this.post<PpaAsProdCreationViewModel[]>('/dreams/ppa/create', new DefaultParams(params));
  }

  @ApiOptions({ requestType: 'form' })
  uploadPPAExcel(params: ParamsAdapter) {
    return this.post<PpaAsProdCreationViewModel[]>('/dreams/ppa/create/upload-excel', params);
  }

  @ApiOptions({ requestType: 'form' })
  getPPAVolumeExcel(params: ParamsAdapter) {
    return this.post<PpaAsProdVolumesViewModel[]>('/dreams/ppa/get-volumes-by-excel', params);
  }
}
